import React from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import { Tooltip } from "@mui/material";
import moment from 'moment';
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { formatAndConcatenateValues } from 'modules/studentRefund/refundMasters/refundsApprovalConfig/refundLogs/constants';

const ListComponent = ({
    rows,
    rowCount = 0,
}) => {

    const excludedKeys = ["revType", "rev", "createdOn", "createdBy", "updatedOn", "updatedBy", "buildingIds", "pincodeId", "stateId", "districtId", "cityId", "addressCategoryId", "addressReferenceType", "referenceId", "status", "isDeleted", "effectiveDate", "countryId",];

    const columns = [
        new AGridColDef("effectiveDate", "Effective Date", true)
            .setMinWidth(40)
            .setFlex(0.6)
            .renderCellComponent((params) => (
                params?.value ? <div><Tooltip title={moment(params?.value).format("DD-MM-YYYY")}>
                    <div className={`ellipsis-text-container`}>{moment(params?.value).format("DD-MM-YYYY")}</div>
                </Tooltip></div> : <div>-</div>
            )),
        new AGridColDef("address", "Address", true)
            .setMinWidth(200)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                <div><Tooltip title={formatAndConcatenateValues(params?.row, excludedKeys)}>
                    <div className={`ellipsis-text-container`}>{formatAndConcatenateValues(params?.row, excludedKeys)}</div>
                </Tooltip></div>
            )),
        new AGridColDef("updatedOn", "Updated On", true)
            .setMinWidth(80)
            .setFlex(0.8)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={`${moment(params?.value).format('DD-MM-YYYY')} ${moment(params?.value).format('hh:mm A')}`}>
                    <div className={`ellipsis-text-container`} >{`${moment(params?.value).format('DD-MM-YYYY')} ${moment(params?.value).format('hh:mm A')}`}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("updatedBy", "Updated By", true)
            .setMinWidth(80)
            .setFlex(0.9)
            .renderCellComponent((params) => (
                params?.value ? <div><Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip></div> : <div>-</div>
            )),
    ];

    return (
        <>
            <div className="mt-3">
                <ADataGrid
                    removeWrapperContainer
                    // rowModesModel={rowModesModel}
                    rows={rows || []}
                    columns={columns}
                    rowId={(row) => row?.id}
                    rowHeight={50}
                    rowCount={rowCount}
                    loading={false}
                    // currentPage={currentPage}
                    // nextButtonHandler={nextButtonHandler}
                    sx={{
                        ...gridStyles,
                    }}
                    autoHeight
                    hidePagination={true}
                // paginationModel={{ page: currentPage, pageSize: currPageSize }}
                />
            </div>
        </>
    )
}

export default ListComponent;
